import { Aurelia, PLATFORM } from 'aurelia-framework';

export function configure(aurelia: any) {
    aurelia
        .globalResources(PLATFORM.moduleName("./authorized-value-converter"))
        .globalResources(PLATFORM.moduleName("./checkbox"))
        .globalResources(PLATFORM.moduleName("./credit-card-expiration"))
        .globalResources(PLATFORM.moduleName("./credit-card-image"))
        .globalResources(PLATFORM.moduleName("./credit-card-name"))
        .globalResources(PLATFORM.moduleName("./credit-card-number"))
        .globalResources(PLATFORM.moduleName("./credit-card-technology"))
        .globalResources(PLATFORM.moduleName("./date-format"))
        .globalResources(PLATFORM.moduleName("./date-format-detailed"))
        .globalResources(PLATFORM.moduleName("./date-only-format"))
        .globalResources(PLATFORM.moduleName("./date-only-format-no-conversion"))
        .globalResources(PLATFORM.moduleName("./friendly-date"))
        .globalResources(PLATFORM.moduleName("./invert-boolean-value-converter"))
        .globalResources(PLATFORM.moduleName("./kiosk-setting-type-filter-value-converter"))
        .globalResources(PLATFORM.moduleName("./kiosk-ticket-template-css-value-converter"))
        .globalResources(PLATFORM.moduleName("./local-date-format"))
        .globalResources(PLATFORM.moduleName("./local-date-format-detailed"))
        .globalResources(PLATFORM.moduleName("./local-date-only-format"))
        .globalResources(PLATFORM.moduleName("./lowercase-value-converter"))
        .globalResources(PLATFORM.moduleName("./sentence-spacing-value-converter"))
        .globalResources(PLATFORM.moduleName("./transaction-amount-value-converter"))
        .globalResources(PLATFORM.moduleName("./transaction-status-value-converter"))
        .globalResources(PLATFORM.moduleName("./transaction-status-description"))
        .globalResources(PLATFORM.moduleName("./viewmodel-from-pascal-case"));
}